/* eslint-disable
    import/no-webpack-loader-syntax,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
require('expose-loader?exposes=$,jQuery!jquery')
require('jquery/jquery-ujs-1.2.3')
require('etc/sign_up')
